import NLS                  from "dashboard/dist/Core/NLS";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    ERROR_LOG_LOADING,
    ERROR_LOG_LIST, ERROR_LOG_ELEM,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    filter    : {
        search   : "",
        fromDate : "",
        toDate   : "",
    },
    sort      : {
        orderBy  : "updatedTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate   = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.updatedDate   = DateTime.formatDate(elem.updatedTime, "dashesTime");
    elem.resolvedText  = elem.isResolved ? NLS.get("ERRORS_LOG_RESOLVED") : "-";
    elem.resolvedColor = elem.isResolved ? "green" : "red";
    elem.errorCode     = `${elem.amount} × ${elem.error} (${elem.code})`;
    elem.fileLine      = `${elem.file} (${elem.line})`;
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, ERROR_LOG_LIST, ERROR_LOG_ELEM)) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case ERROR_LOG_LOADING:
        return {
            ...state,
            loading   : true,
        };

    case ERROR_LOG_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            filter    : action.data.filter,
            sort      : action.data.sort,
        };

    case ERROR_LOG_ELEM:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            elem      : parseElem(action.data.elem),
        };

    default:
        return state;
    }
};

export default reducer;
